import { render, staticRenderFns } from "./matchResDetail.vue?vue&type=template&id=39ddbe72&scoped=true"
import script from "./matchResDetail.vue?vue&type=script&lang=js"
export * from "./matchResDetail.vue?vue&type=script&lang=js"
import style0 from "./matchResDetail.vue?vue&type=style&index=0&id=39ddbe72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ddbe72",
  null
  
)

export default component.exports